export const data = [
  {
    "Title": "Adventures of the Fly",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventures of the Fly",
    "Issue #": 21,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventures of the Jaguar",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventures of the Jaguar",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": ""
  },
  {
    "Title": "Adventure With the Brothers",
    "Issue #": "Cult Escape",
    "Condition": "VF",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Adventure With the Brothers",
    "Issue #": "Smashing Smugglers Ring",
    "Condition": "VF",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie",
    "Issue #": 40,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Archie",
    "Issue #": 50,
    "Condition": "CGC 4.5",
    "Website Notes": "Classic Betty Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 850,
    "": ""
  },
  {
    "Title": "Archie and Mr Weatherbee",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie at Riverdale High",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Archie as Pureheart Powerful",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Archie Giant Series Magazine",
    "Issue #": 195,
    "Condition": "F/VF",
    "Website Notes": "Christmas Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 16,
    "": ""
  },
  {
    "Title": "Archie Giant Series Magazine",
    "Issue #": 204,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Archie's Girls Betty and Veronica",
    "Issue #": 23,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Archie's Girls Betty and Veronica",
    "Issue #": 26,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Archie's Girls Betty and Veronica",
    "Issue #": 72,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Rapid City"
  },
  {
    "Title": "Archie's Girls Betty and Veronica",
    "Issue #": 105,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's Girls Betty and Veronica",
    "Issue #": 320,
    "Condition": "CBCS 9.4",
    "Website Notes": "1st Cheryl Blossom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": ""
  },
  {
    "Title": "Archie's Girls Betty and Veronica",
    "Issue #": 320,
    "Condition": "VF+",
    "Website Notes": "1st Cheryl Blossom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Archie's Girls Betty and Veronica Annual",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 13,
    "": ""
  },
  {
    "Title": "Archie's Jokes",
    "Issue #": 22,
    "Condition": "VG/F",
    "Website Notes": "1963 Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Vince"
  },
  {
    "Title": "Archie's Madhouse",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Archie's Madhouse",
    "Issue #": 8,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Archie Meets Kiss",
    "Issue #": "627-630",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie Meets the Punisher",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's Clean Slate",
    "Issue #": "",
    "Condition": "FN",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's Date Book",
    "Issue #": "",
    "Condition": "FN",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's Festival",
    "Issue #": "",
    "Condition": "VF+",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's Love Scene",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's One Way",
    "Issue #": "",
    "Condition": "VF",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's Parables",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's Pal Jughead",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Archie's Pal Jughead Annual",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": ""
  },
  {
    "Title": "Archie's Pals 'N' Gals",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Archie's Pals 'N' Gals",
    "Issue #": 19,
    "Condition": "FN",
    "Website Notes": "M. Monroe",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Archie's Rival Reggie",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Rapid City"
  },
  {
    "Title": "Archie's Roller Coaster",
    "Issue #": "",
    "Condition": "VF",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Archie's TV Laugh Out",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Chilling Adventures in Sorcery",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Sabrina",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Cosmo the Merry Martian",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Brian"
  },
  {
    "Title": "Fly Girl",
    "Issue #": 39,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Gospel Blimp",
    "Issue #": "",
    "Condition": "FN",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Hansi",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": ".39 Cvr 1st Print",
    "Personal Notes (Not on website)": "Spire",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Jesus",
    "Issue #": "",
    "Condition": "NM-",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Jughead's Folly",
    "Issue #": 1,
    "Condition": "CGC 5.5",
    "Website Notes": "Scarce 1960",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 155,
    "": ""
  },
  {
    "Title": "Katy Keene",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Katy Keene",
    "Issue #": 60,
    "Condition": "G/VG",
    "Website Notes": "Octopus Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "BCC"
  },
  {
    "Title": "Laugh",
    "Issue #": 38,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Life With Archie",
    "Issue #": 49,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Life With Archie",
    "Issue #": 53,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Life With Archie",
    "Issue #": 54,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Life With Archie",
    "Issue #": 57,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Life With Archie",
    "Issue #": 62,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Little Archie",
    "Issue #": 56,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Little Archie",
    "Issue #": 69,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "On the Road Andrae Grouch",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "Spire",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "On the Road Andrae Grouch",
    "Issue #": "",
    "Condition": "F/VF",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Paul",
    "Issue #": "",
    "Condition": "",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sabrina",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Suzie",
    "Issue #": 79,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Age Mutant Ninja Turtles Adventures",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Mini Series",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Up From Harlem",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "Christian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wilbur",
    "Issue #": 35,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Gilligans"
  }
]
;
